<app-de-wrapper *ngIf="loading">
  <app-spinner></app-spinner>
</app-de-wrapper>

<app-de-wrapper *ngIf="!loading">
  <div class="container">
    <h1 class="heading">{{ state.checkoutCustomizations.merchantPrecheckTitle }}</h1>
    <p class="sub-heading">{{ state.checkoutCustomizations.merchantPrecheckDescription }}</p>

    <form [formGroup]="form">
      <div class="input-container-wrapper">
        <span class="euro" [style.font-size]="fontSize + 'px'">€ </span>
        <input
          #amountInput
          class="formatted-amount"
          inputType="text"
          inputMode="decimal"
          [style.font-size]="fontSize + 'px'"
          [style.width]="inputWidth + 'ch'"
          [maxlength]="maxLength"
          [formControlName]="'amount'"
        />
      </div>
    </form>

    <p class="info-text">(Klicken Sie zum Bearbeiten)</p>
  </div>

  <div class="footer-wrapper">
    <div class="footer-container">
      <div
        *ngIf="form.controls.amount.invalid && showError"
        class="error-wrapper"
      >
        <img
          src="assets/icon/icon_error.svg"
          alt="Checkout Icon"
          class="error-icon"
        />
        <p class="error-text">Bitte geben Sie einen gültigen Betrag ein</p>
      </div>
      <div class="button-wrapper">
        <zaver-primary-button
          (click)="handleCtaClick()"
          [text]="'Weiter'"
          [disabled]="navigationInProgress"
        ></zaver-primary-button>
      </div>
    </div>
  </div>
</app-de-wrapper>
